"use client";

import { CalloutPlugin } from "@platejs/callout/react";

import { CalloutElement } from "../../ui/callout-node";

export const CalloutKit = [CalloutPlugin.withComponent(CalloutElement)];
